(function () {
  'use strict';

  angular.module('ringbaPortal.services').factory('campaignAffiliateService', campaignAffiliateService);

  function campaignAffiliateService(
    $http,
    $q,
    callTrackingTagService,
    campaignServiceNew,
    numberService,
    payoutService
  ) {
    'ngInject';

    const publisherFilterMap = {
      'All': function () {
        return true;
      },
      'Offer Publishers': function (pub) {
        return pub.offerPub;
      },
      'Non-offer Publishers': function (pub) {
        return !pub.offerPub;
      }
    };

    const service = {
      addAffiliate: addAffiliate,
      deleteAffiliate: deleteAffiliate,
      addAffiliateNumber: addAffiliateNumber,
      getAffiliatePayoutSettings: getAffiliatePayoutSettings,
      addAffiliatePayoutSetting: addAffiliatePayoutSetting,
      updateAffiliatePayoutSetting: updateAffiliatePayoutSetting,
      deleteAffiliatePayoutSettingWithId: deleteAffiliatePayoutSettingWithId,
      segregatePayoutSettings: segregatePayoutSettings,
      setAffiliateNumbersList: setAffiliateNumbersList,
      addAffiliateWithNumbers: addAffiliateWithNumbers,
      batchUpdatePayoutSettings: batchUpdatePayoutSettings,
      setAffiliateNumber: setAffiliateNumber,
      setPayoutSettings: setPayoutSettings,
      publisherFilterMap: publisherFilterMap
    };

    return service;

    function addAffiliate(accountId, campaignId, affiliateId, payoutSetting) {
      const url = campaignServiceNew.serviceBaseUrl(accountId, campaignId) + '/affiliates';
      const data = { publisherId: affiliateId, payoutSetting: payoutSetting };
      return $http.patch(url, data);
    }

    function deleteAffiliate(accountId, campaignId, affiliateId) {
      const url = campaignServiceNew.serviceBaseUrl(accountId, campaignId) + '/affiliates/' + affiliateId;
      return $http.delete(url);
    }

    function addAffiliateNumber(accountId, campaignId, numberId) {
      const url = campaignServiceNew.serviceBaseUrl(accountId, campaignId) + '/affiliateNumbers';
      const data = { numberId: numberId };
      return $http.patch(url, data);
    }

    function getAffiliatePayoutSettings(accountId, campaignId, affiliateId) {
      const url = _serviceBaseUrlForAffiliatePayout(accountId, campaignId, affiliateId);
      return $http.get(url).then(function (response) {
        response.data.payoutSettings = payoutService.sanitizePayoutsForDisplay(response.data.payoutSettings);
        return response;
      });
    }

    function addAffiliatePayoutSetting(accountId, campaignId, affiliateId, payoutSetting) {
      const url = _serviceBaseUrlForAffiliatePayout(accountId, campaignId, affiliateId);
      return $http.post(url, payoutSetting);
    }

    function updateAffiliatePayoutSetting(accountId, campaignId, affiliateId, payoutSetting) {
      const url = _serviceBaseUrlForAffiliatePayout(accountId, campaignId, affiliateId, payoutSetting.id);
      return $http.patch(url, payoutSetting);
    }

    function deleteAffiliatePayoutSettingWithId(accountId, campaignId, affiliateId, payoutSettingId) {
      const url = _serviceBaseUrlForAffiliatePayout(accountId, campaignId, affiliateId, payoutSettingId);
      return $http.delete(url);
    }

    function addAffiliateWithNumbers(accountId, data, addNewAffiliate) {
      let initialPromise;
      if (addNewAffiliate) {
        initialPromise = addAffiliate(accountId, data.campaign.id, data.affiliateId);
      } else {
        initialPromise = $q.when({});
      }

      return initialPromise.then(function () {
        if (!data.createNewNumber) {
          return _addNumbers(accountId, data.numbersToAdd, data.affiliateId);
        } else {
          return _createNumber(accountId, data.campaign, data.affiliateId, data.assignmentSettings || {});
        }
      }).then(function (numbersToAdd) {
        return _addAffiliateNumbers(accountId, data.campaign.id, numbersToAdd);
      });
    }

    function batchUpdatePayoutSettings(accountId, campaignId, affiliateId, payoutSettings, notifyPubs) {
      const url = _serviceBaseUrlForAffiliatePayout(accountId, campaignId, affiliateId);
      const data = {
        allPayouts: payoutSettings,
        sendNotifications: notifyPubs
      };
      return $http.put(url, data);
    }

    function segregatePayoutSettings(payoutSettings) {
      if (angular.isArray(payoutSettings)) {
        const firstUnfilteredPayoutIndex = _.findIndex(payoutSettings, function (payout) {
          return payout.payoutConversionType === 'incomingCall' && (!payout.criteria || !payout.criteria.length);
        });

        return _.map(payoutSettings, function (payout, index) {
          if (firstUnfilteredPayoutIndex > -1 && index > firstUnfilteredPayoutIndex) {
            payout.notUsedPayout = true;
          } else {
            payout.notUsedPayout = false;
          }
          return payout;
        });
      }
    }

    function setAffiliateNumbersList(accountId, campaign, affiliates, affiliateNumbers) {
      const finalList = angular.copy(affiliates);
      _.forEach(finalList, function (affiliate) {
        setAffiliateNumber(accountId, campaign, affiliate, affiliateNumbers);
      });
      return finalList;
    }

    function setAffiliateNumber(accountId, campaign, affiliate, affiliateNumbers) {
      setPayoutSettings(accountId, campaign, affiliate);
      affiliate.phoneNumbers = _.map(
        _.filter(affiliateNumbers, function (number) {
          return number.affiliate && number.affiliate.id === affiliate.id;
        }), function (number) {
          const numberObj = {
            phoneNumber: number.phoneNumber,
            numberId: number.id,
            offerId: number.offerId,
            isInternalOnly: number.isInternalOnly,
            enabled: number.enabled
          };

          if (number.jsTagId) {
            const tag = _.find(campaign.jsTags, { id: number.jsTagId });
            if (tag) {
              numberObj.jsTagName = tag.name;
              numberObj.jsTagId = tag.id;
            }
          }

          if (campaign.pubNumberEnrichmentUrls) {
            const key = '_' + number.id;

            if (key && campaign.pubNumberEnrichmentUrls[key]) {
              numberObj.pubNumberEnrichmentUrl = campaign.pubNumberEnrichmentUrls[key];
            }
          }

          return numberObj;
        });
      return affiliate;
    }

    function setPayoutSettings(accountId, campaign, affiliate) {
      let promise;

      if (affiliate && Array.isArray(affiliate.payoutConversionSettings)) {
        promise = $q.when({ data: { payoutSettings: affiliate.payoutConversionSettings } });
      } else if (campaign.affiliates && campaign.affiliates.length > 0) {
        const pub = _.find(campaign.affiliates, { id: affiliate.id });
        if (pub && Array.isArray(pub.payoutConversionSettings)) {
          promise = $q.when({ data: { payoutSettings: pub.payoutConversionSettings } });
        } else {
          promise = getAffiliatePayoutSettings(accountId, campaign.id, affiliate.id);
        }
      } else {
        promise = getAffiliatePayoutSettings(accountId, campaign.id, affiliate.id);
      }
      return promise.then(function (response) {
        let payouts;
        if (response.data.payoutSettings.length) {
          affiliate.payoutsOverridden = 'overridden';
          payouts = response.data.payoutSettings;
        } else if (campaign.defaultPayouts && campaign.defaultPayouts.length) {
          affiliate.payoutsOverridden = 'campaign';
          payouts = [];
        } else {
          affiliate.payoutsOverridden = 'none';
          payouts = [];
        }
        affiliate.payoutSettingsList = segregatePayoutSettings(payouts);
      });
    }

    function _addNumbers(accountId, numbers, affiliateId) {
      const attachAffiliatesPromises = [];
      _.forEach(numbers, function (number) {
        if (number && !number.affiliate) {
          attachAffiliatesPromises.push(numberService.attachAffiliate(accountId, number.id, affiliateId));
        } else {
          attachAffiliatesPromises.push($q.when({}));
        }
      });

      return $q.all(attachAffiliatesPromises).then(function () {
        return numbers;
      });
    }

    function _createNumber(accountId, campaign, affiliateId, assignmentSettings) {
      assignmentSettings.countryCode = campaign.countryCode;
      return numberService.createNumber(accountId, assignmentSettings)
        .then(function (response) {
          if (response.data && response.data.number) {
            return _addNumbers(accountId, [response.data.number], affiliateId);
          }
        });
    }

    function _addAffiliateNumbers(accountId, campaignId, numbers) {
      return numbers.reduce(function (promise, number) {
        return promise.then(function () {
          return addAffiliateNumber(accountId, campaignId, number.id);
        });
      }, $q.when({}));
    }

    function _serviceBaseUrlForAffiliatePayout(accountId, campaignId, affiliateId, payoutId) {
      return campaignServiceNew.serviceBaseUrl(accountId, campaignId) + '/affiliates/' + affiliateId + '/payouts' + (payoutId ? '/' + payoutId : '');
    }


  }
})();
